import { Box } from "@mui/material";
import "boxicons";
import { useLayoutEffect } from "react";
import ReactGA from "react-ga4";

import About from "./components/About/About";
import LiveChat from "./components/Chat/LiveChat";
import Contact from "./components/Contact/Contact";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Projects from "./components/Projects/Projects";
import Services from "./components/Services/Services";
import Skills from "./components/Skills/Skills";

import "./App.css";

const KEY = process.env.REACT_APP_GOOGLE_ANALYTIC_ID;

function App() {
  ReactGA.initialize(KEY);
  // Send pageview with a custom path
  ReactGA.send({
    hitType: "pageview",
    page: "*",
    title: "Custom Title",
  });

  // animation on scroll
  useLayoutEffect(() => {
    const fromRight = document.querySelectorAll("#fromRight");
    const observer = new IntersectionObserver(callback);
    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fromRight");
        }
      });
    }
    if (fromRight.length) {
      fromRight.forEach((item) => observer.observe(item));
    }
  }, []);

  useLayoutEffect(() => {
    const fromLeft = document.querySelectorAll("#fromLeft");

    const observer = new IntersectionObserver(callback);
    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fromLeft");
        }
      });
    }
    if (fromLeft.length) {
      fromLeft.forEach((item) => observer.observe(item));
    }
  }, []);

  useLayoutEffect(() => {
    const fromTop = document.querySelectorAll("#fromTop");

    const observer = new IntersectionObserver(callback);
    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fromTop");
        }
      });
    }
    if (fromTop.length) {
      fromTop.forEach((item) => observer.observe(item));
    }
  }, []);

  useLayoutEffect(() => {
    const fromBottom = document.querySelectorAll("#fromBottom");

    const observer = new IntersectionObserver(callback);
    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fromBottom");
        }
      });
    }
    if (fromBottom.length) {
      fromBottom.forEach((item) => observer.observe(item));
    }
  }, []);

  useLayoutEffect(() => {
    const list = document.querySelectorAll("#list");

    const observer = new IntersectionObserver(callback);
    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("list");
        }
      });
    }
    if (list.length) {
      list.forEach((item) => observer.observe(item));
    }
  }, []);

  return (
    <div className="App relative">
      <div className="free-palestine">{/* <img src="/assets/free-palestine.jpg" /> */}</div>
      <LiveChat />

      <Box
        component={"a"}
        href="#top"
        sx={{
          bgcolor: "#0ef",
          position: "fixed",
          bottom: "10px",
          left: "10px",
          borderRadius: "4px",
          cursor: "pointer",
          zIndex: "tooltip",
          "&:hover": { p: 0.3, boxShadow: "0 0 3px 1px #fff" },
        }}
      >
        <box-icon name="up-arrow-alt" size="md" color="#fff"></box-icon>
      </Box>
      <Header />
      <Home />
      <About />
      <Services />
      <Skills />
      <Projects />
      <Contact />

      {/* <Fun /> */}
    </div>
  );
}

export default App;
